import { InteractionMetric } from "@edgetier/watchtower-types";
import { isBooleanMetric } from "utilities-for/metrics/is-boolean-metric";

/**
 * Get the minimum value for a chart selection.
 * @param metric The metric that's being displayed.
 * @param event  The mouse event callback event.
 * @returns The minimum value for the event.
 */
export const getMinimumValue = (metric: InteractionMetric, event: any) => {
    if (isBooleanMetric(metric)) {
        return event?.activePayload?.[0]?.payload?.value ?? null;
    }

    return event?.activePayload?.[0]?.payload?.minimumValue ?? null;
};

/**
 * Get the maximum value for a chart selection.
 * @param metric The metric that's being displayed.
 * @param event  The mouse event callback event.
 * @returns The maximum value for the event.
 */
export const getMaximumValue = (metric: InteractionMetric, event: any) => {
    if (isBooleanMetric(metric)) {
        return event?.activePayload?.[0]?.payload?.value ?? null;
    }

    return event?.activePayload?.[0]?.payload?.maximumValue ?? null;
};
